import React, { useContext } from 'react';
import { View, Text } from 'react-native';
import { useAuth } from 'app/auth/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { getDoctorTitle } from '@shared/utils/doctor';


const HiHeaderComponent = () => {
    const { logout, user, meData } = useAuth();
    const { t } = useTranslation();
    const insets = useSafeAreaInsets();
    const doctor = meData?.current_pathway?.doctor;
    const docTitle = getDoctorTitle(doctor?.title, t);

    return (
        <View
        className='px-8 pb-6 bg-primary-700 rounded-b-[50px] mb-8'
            style={{ paddingTop: insets.top + 32 }}>
            <Text className='font-heading font-bold mt-3 text-white text-5xl' >
                {t('screens.home.header.hello')} {user?.given_name}!
           </Text>
            <Text className='font-body text-white mt-4 text-base' >
                {`${t('screens.home.header.doctor')}: ${docTitle} ${doctor?.last_name
                    }`}
            </Text>
        </View>
    );
};

export default HiHeaderComponent;
